interface Profile {
    label: string;
    value: string;
}
export const ProfileArray: Profile[] = [
    { label: "Choose any", value: "" },
    { label: "AI Developer", value: "AI Developer" },
    { label: "Solution Architect", value: "Solution Architect" },
    {
        label: "AngularJS Developer",
        value: "AngularJS Developer",
    },
    { label: "Node.js Developer", value: "Node.js Developer" },
    { label: "Ionic Developer", value: "Ionic Developer" },
    { label: "Android Developer", value: "Android Developer" },
    {
        label: "iPhone/Ios Developer",
        value: "iPhone/Ios Developer",
    },
    { label: "Magento Developer", value: "Magento Developer" },
    { label: "PHP Developer", value: "PHP Developer" },
    { label: "DotNet Developer", value: "DotNet Developer" },
    { label: "UI/UX Designers", value: "UI/UX Designers" },
    { label: "Quality Analyst", value: "Quality Analyst" },
    {
        label: "Business Analyst (Pre-Sales)",
        value: "Business Analyst (Pre-Sales)",
    },
    {
        label: "Business Analyst (Post-Sales)",
        value: "Business Analyst (Post-Sales)",
    },
    { label: "Content Writer", value: "Content Writer" },
    { label: "SEO Executive", value: "SEO Executive" },

]